import type { MyDocumentsSummary } from "@/modules/quotation-invoice/domain/types";

export type MyDocumentsCountSummary = {
  quotationCount: number;
  invoiceCount: number;
  receiptCount: number;
  draftCount: number;
  totalDocuments: number;
};

export function computeMyDocumentsCountSummary(
  data: MyDocumentsSummary | undefined,
): MyDocumentsCountSummary {
  if (!data) {
    return {
      quotationCount: 0,
      invoiceCount: 0,
      receiptCount: 0,
      draftCount: 0,
      totalDocuments: 0,
    };
  }

  const quotationCount = data.byDocumentType.quotationIssued.count;
  const invoiceCount = data.byDocumentType.invoiceOpen.count;
  const receiptCount = data.byDocumentType.receiptAll.count;
  const draftCount = data.draft.count;

  return {
    quotationCount,
    invoiceCount,
    receiptCount,
    draftCount,
    totalDocuments: quotationCount + invoiceCount + receiptCount + draftCount,
  };
}
